import ArtistBio from '@/components/Artist/ArtistBio';
import EventList from '@/components/Event/EventList';
import { EventListItemProps } from '@/components/Event/EventListItem';
import DetailCard from '@/components/Module/DetailCard';
import Divider from '@/components/Module/Divider';
import useViewport from '@/hooks/useViewport';

export type ArtistDetailProps = {
  imageUrl: string;
  name: string;
  bio: string;
  websiteUrl?: string | null;
  facebookUrl?: string | null;
  instagramUrl?: string | null;
  spotifyUrl?: string | null;
  events: EventListItemProps[];
};

const MobileArtistDetail = (props: ArtistDetailProps) => {
  const {
    imageUrl,
    name,
    bio,
    websiteUrl,
    facebookUrl,
    instagramUrl,
    spotifyUrl,
    events,
  } = props;

  return (
    <DetailCard
      type={`Artist`}
      name={name}
      imageUrl={imageUrl}
      instagramUrl={instagramUrl}
      websiteUrl={websiteUrl}
      facebookUrl={facebookUrl}
      spotifyUrl={spotifyUrl}
    >
      <Divider my={56} />
      <div className="flex flex-col gap-[32px]">
        <p className="text-h3 font-bold text-gray-300">About</p>
        <ArtistBio bio={bio} maxLengthInShort={165} />
      </div>
      <Divider my={56} />
      <EventList events={events} />
    </DetailCard>
  );
};

const DesktopArtistDetail = (props: ArtistDetailProps) => {
  const {
    imageUrl,
    name,
    bio,
    websiteUrl,
    facebookUrl,
    instagramUrl,
    spotifyUrl,
    events,
  } = props;

  return (
    <DetailCard
      type={`Artist`}
      name={name}
      imageUrl={imageUrl}
      instagramUrl={instagramUrl}
      websiteUrl={websiteUrl}
      facebookUrl={facebookUrl}
      spotifyUrl={spotifyUrl}
    >
      <Divider my={79} />
      <div className="flex flex-col gap-[40px]">
        <p className="text-h1 font-bold text-gray-500">About</p>
        <ArtistBio bio={bio} maxLengthInShort={420} />
      </div>
      <Divider my={79} />
      <EventList events={events} />
    </DetailCard>
  );
};

const ArtistDetail = (props: ArtistDetailProps) => {
  const {} = props;
  const viewport = useViewport();

  if (viewport == `mobile` || viewport == `tablet`) {
    return <MobileArtistDetail {...props} />;
  }
  if (viewport == `desktop`) {
    return <DesktopArtistDetail {...props} />;
  }

  return null;
};

export default ArtistDetail;
